import i18next from 'i18next'
import {useEffect, useState} from 'react'
import {Col, Form, Row} from 'react-bootstrap'
import {useTranslation} from 'react-i18next'
import {getChild as getOrderSubmission} from 'src/api/modules/order'
import {useAppDispatch, useAppSelector} from 'src/redux/hooks'
import {notificationSelector, setNotification} from 'src/redux/slices/notificationSlices'
import swal from 'sweetalert'
import {CustomModal} from '../CustomModal'

/** @deprecated */
export const NegotiationDetailModal = () => {
  const {t} = useTranslation()
  const [showDetail, setShowDetail] = useState(false)
  const [detailOrder, setDetailOrder] = useState<any>({})
  const [btnLoading, setBtnLoading] = useState(false)
  const {notification} = useAppSelector(notificationSelector)
  const dispatch = useAppDispatch()

  const fetchOrderSubmission = async () => {
    if (!notification) return
    if (notification.type !== 'negotiation') return

    setBtnLoading(true)

    getOrderSubmission(notification.child_id)
      .then((res) => {
        setDetailOrder(res.data.data)
        setShowDetail(true)
      })
      .catch((error: any) => {
        swal({
          title: 'Error',
          text: error?.message ?? 'Failed fetch order submission',
        })
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  const handleCloseModal = () => {
    dispatch(setNotification(null))
    setShowDetail(false)
  }

  useEffect(() => {
    if (!notification) return
    if (notification.type !== 'negotiation') return
    fetchOrderSubmission()
  }, [notification])

  useEffect(() => {
    return () => {
      dispatch(setNotification(null))
    }
  }, [])

  if (!notification || !detailOrder) return null

  return (
    <CustomModal
      title={notification?.title}
      show={showDetail}
      centered
      size='xl'
      onHide={handleCloseModal}
    >
      <Row>
        <Col md={6}>
          <Row className='mb-5'>
            <Col md={4}>
              <p className='mt-3 fs-6'>Sales Org</p>
            </Col>
            <Col md={8}>
              <Form.Control value={detailOrder.produsen?.name} type='text' size='sm' disabled />
            </Col>
          </Row>

          <Row className='mb-5'>
            <Col md={4}>
              <p className='mt-3 fs-6'>Incoterm</p>
            </Col>
            <Col md={8}>
              <Form.Control value={detailOrder.incoterm1?.code} type='text' size='sm' disabled />
            </Col>
          </Row>

          <Row className='mb-5'>
            <Col md={4}>
              <p className='mt-3 fs-6'>{t('sub-order-provinsi')}</p>
            </Col>
            <Col md={8}>
              <Form.Control
                value={detailOrder.province?.region_name}
                type='text'
                size='sm'
                disabled
              />
            </Col>
          </Row>

          <Row className='mb-5'>
            <Col md={4}>
              <p className='mt-3 fs-6'>{t('sub-order-jenis')}</p>
            </Col>
            <Col md={8}>
              <Form.Control value={detailOrder.product_type_desc} type='text' size='sm' disabled />
            </Col>
          </Row>

          <Row className='mb-5'>
            <Col md={4}>
              <p className='mt-3 fs-6'>{t('sub-order-kuantum')}</p>
            </Col>
            <Col md={8}>
              <Form.Control
                value={
                  (i18next.language === 'en'
                    ? detailOrder.request_quantum?.toLocaleString('en', {
                        maximumFractionDigits: 4,
                      })
                    : detailOrder.request_quantum?.toLocaleString('id', {
                        maximumFractionDigits: 4,
                      })) + (detailOrder.sector_id == 1 ? '/Ton' : '/MT')
                }
                type='text'
                size='sm'
                disabled
              />
            </Col>
          </Row>

          <Row className='mb-5'>
            <Col sm={4} className='d-flex align-items-center'>
              <p className='fs-6'>{t('Shipping Tolerance')}</p>
            </Col>
            <Col sm={8}>
              <Form.Control
                size='sm'
                type='text'
                id='shipping'
                value={
                  detailOrder?.shipping_tolerance === '0'
                    ? ''
                    : detailOrder?.shipping_tolerance + '%'
                }
                disabled
              />
            </Col>
          </Row>
          <Row className='mb-5'>
            <Col md={4}>
              <p className='mt-3 fs-6'>{t('sub-order-payment1')}</p>
            </Col>
            <Col md={8}>
              <Form.Control
                value={detailOrder.payment_type_1_desc}
                type='text'
                size='sm'
                disabled
              />
            </Col>
          </Row>

          <Row className='mb-5'>
            <Col md={4} className='d-flex align-items-center'>
              <p className='fs-6'>{t('keterangan')}</p>
            </Col>
            <Col md={8}>
              <Form.Control
                value={detailOrder?.payment_note}
                as='textarea'
                style={{height: '40px'}}
                disabled
                size='sm'
              />
            </Col>
          </Row>

          {detailOrder?.sector_id == 1 ? (
            <>
              <Row className='mb-5'>
                <Col md={4}>
                  <p className='mt-3 fs-6'>{t('Segment')}</p>
                </Col>
                <Col md={8}>
                  <Form.Control value={detailOrder.segment_name} type='text' size='sm' disabled />
                </Col>
              </Row>
            </>
          ) : (
            <></>
          )}

          <Row className='mb-5'>
            <Col md={4} className='d-flex align-items-center'>
              <p className='fs-6'>{t('sub-order-endUser')}</p>
            </Col>
            <Col md={8}>
              <Form.Control
                as='textarea'
                value={
                  detailOrder?.end_user_detail?.name
                    ? detailOrder?.end_user_detail?.name
                    : detailOrder?.end_user
                }
                type='text'
                disabled
                size='sm'
              />
            </Col>
          </Row>
        </Col>

        <Col md={6}>
          <Row className='mb-5'>
            <Col md={4}>
              <p className='mt-3 fs-6'>{t('sub-order-sektor')}</p>
            </Col>
            <Col md={8}>
              <Form.Control value={t(detailOrder.sector?.name)} type='text' size='sm' disabled />
            </Col>
          </Row>

          <Row className='mb-5'>
            <Col md={4} className='d-flex align-items-center'>
              <p className='fs-6'>{t('sub-order-incoterm2')}</p>
            </Col>
            <Col md={8}>
              {detailOrder?.incoterm2 == null ? (
                <Form.Control
                  value={
                    detailOrder?.incoterm2_id == null || detailOrder?.incoterm2_id == '0'
                      ? ''
                      : detailOrder?.incoterm2_id
                  }
                  type='text'
                  disabled
                  size='sm'
                />
              ) : (
                <Form.Control value={detailOrder?.incoterm2?.code} type='text' disabled size='sm' />
              )}
            </Col>
          </Row>

          <Row className='mb-5'>
            <Col md={4}>
              <p className='mt-3 fs-6'>{t('sub-order-kota')}</p>
            </Col>
            <Col md={8}>
              <Form.Control value={detailOrder.city?.city_name} type='text' size='sm' disabled />
            </Col>
          </Row>

          <Row className='mb-5'>
            <Col md={4}>
              <p className='mt-3 fs-6'>{t('sub-order-produk')}</p>
            </Col>
            <Col md={8}>
              <Form.Control value={detailOrder.product_name} type='text' size='sm' disabled />
            </Col>
          </Row>

          <Row className='mb-5'>
            <Col md={4} className='d-flex align-items-center'>
              <p className='fs-6'>
                {t('sub-order-hargaP')}/{detailOrder.sector_id == 1 ? 'Ton' : 'MT'}
              </p>
            </Col>
            <Col md={8}>
              <Form.Control
                value={
                  (detailOrder.sector_id == 1 ? 'Rp' : 'USD') +
                  (i18next.language === 'en'
                    ? detailOrder.request_price?.toLocaleString('en', {
                        maximumFractionDigits: 4,
                      })
                    : detailOrder.request_price?.toLocaleString('id', {
                        maximumFractionDigits: 4,
                      })) +
                  (detailOrder.sector_id == 1 ? '/Ton' : '/MT')
                }
                type='text'
                size='sm'
                disabled
              />
            </Col>
          </Row>

          {detailOrder.sector_id == 3 ? (
            <>
              <Row className='mb-5'>
                <Col sm={4} className='d-flex align-items-center'>
                  <p className='fs-6'>{t('Formulated Price')}</p>
                </Col>
                <Col sm={8} className='d-flex justify-content-start'>
                  <Form.Check
                    reverse
                    name='formula_Price'
                    className='mt-5 mb-2'
                    type='checkbox'
                    id='formula_Price'
                    checked={detailOrder?.is_formulated_price}
                  />
                </Col>
              </Row>
            </>
          ) : (
            <>
              <Row className='my-7'>
                <Col sm={6} className='d-flex'>
                  <Row sm={8} className='d-flex align-items-center'>
                    <p className='fs-6'>{t('termasuk-ppn')}</p>
                  </Row>
                  <Row sm={4} className='d-flex justify-content-start align-items-center ms-4'>
                    <Form.Check
                      reverse
                      name='ppn'
                      type='checkbox'
                      id='ckbox-ppn'
                      checked={detailOrder?.include_ppn}
                    />
                  </Row>
                </Col>

                <Col sm={6} className='d-flex'>
                  <Row sm={8} className='d-flex align-items-center'>
                    <p className='fs-6'>{t('Formulated Price')}</p>
                  </Row>
                  <Row sm={4} className='d-flex justify-content-start align-items-center ms-4'>
                    <Form.Check
                      reverse
                      name='formula_Price'
                      type='checkbox'
                      id='formula_Price'
                      checked={detailOrder?.is_formulated_price}
                    />
                  </Row>
                </Col>
              </Row>
            </>
          )}
          {detailOrder.sector_id == 3 ? (
            <>
              <Row className='mb-5'>
                <Col md={4} className='d-flex align-items-center'>
                  <p className='fs-6'>{t('sub-order-spek')}</p>
                </Col>
                <Col md={8}>
                  <Form.Control
                    value={detailOrder.product_spec}
                    style={{height: '40px'}}
                    as='textarea'
                    disabled
                    size='sm'
                  />
                </Col>
              </Row>
            </>
          ) : (
            <></>
          )}

          <Row className='mb-5'>
            <Col md={4}>
              <p className='mt-3 fs-6'>{t('sub-order-payment2')}</p>
            </Col>
            <Col md={8}>
              <Form.Control
                value={detailOrder.payment_type_2_desc}
                type='text'
                size='sm'
                disabled
              />
            </Col>
          </Row>
          {detailOrder.sector_id == 3 ? (
            <></>
          ) : (
            <>
              <Row className='mb-5'>
                <Col md={4} className='d-flex align-items-center'>
                  <p className='fs-6'>{t('sub-order-spek')}</p>
                </Col>
                <Col md={8}>
                  <Form.Control
                    value={detailOrder.product_spec}
                    as='textarea'
                    style={{height: '40px'}}
                    disabled
                    size='sm'
                  />
                </Col>
              </Row>
            </>
          )}
          <Row className='mb-5'>
            <Col md={4}>
              <p className='mt-3 fs-6'>{t('sub-order-catatan')}</p>
            </Col>
            <Col md={8}>
              <Form.Control
                value={detailOrder.notes}
                as='textarea'
                style={{height: '40px'}}
                size='sm'
                disabled
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </CustomModal>
  )
}
